import { gameAction } from "_actions";
import { GameService } from "_services";
import React, { useEffect, useState } from "react";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import ScrollableListView from "./ScrollableListView";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import { de } from "date-fns/locale";
import PragmaticGameBox from "../GamerBoxes/PragmaticGameBox";
import DetroitBox from "../GamerBoxes/DetroitBox";

import { detroidGames } from "BaseServiceURLs";
import TimelessTechGameBox from "../GamerBoxes/TimelessTechGameBox";
import Footer from "../Home/Footer";
import MatGameBox from "../GamerBoxes/MatGameBox";
import InnovaBox from "../GamerBoxes/InnovaBox";
import { gamesGameTypes } from "BaseServiceURLs";
import { virtualGameTypes } from "BaseServiceURLs";
import { isGameLaunchAllowed } from "../gameLaunchAccess";

const Casino = (props) => {
  const { user, loggedIn, sports, games, UpdateGames,allGamesGameTypes } = props;
  const [loading, setLoading] = useState(false);
  const [currentProvider, setCurrentProvider] = useState("pragmatic-casino");
  const [FilterSearchValue, setFilterSearchValue] = useState("");

  let params = GetParams();

  function GetParams() {
    let params = useParams();
    return params;
  }
  useEffect(() => {
    getGames();
  }, []);

  useEffect(() => {
    if (games && params && params.ProviderId) {
      if (games.hasOwnProperty(params.ProviderId)) {
        setCurrentProvider(params.ProviderId);
      }
    } else {
      setCurrentProvider("pragmatic-casino");
    }
  }, [games, params.ProviderId]);

  const getGames = async () => {
    setLoading(true);
    await GameService.GET_GAMES()
      .then((res) => {
        setLoading(false);

        const newData = res.map((x) => {
          let y = x;
          if (x.middleware == "blas975") {
            y.CacheData = x.CacheData.reverse();
            return y;
          } else {
            return x;
          }
        });
        debugger;
        UpdateGames(newData);
      })
      .catch((err) => {
        debugger;

        setLoading(false);
      });
  };
  const pb = require("../../../assets/img/banners/games2.png");
  const pragmaticNotCasino = ["1301", "1320"]; //"1302",
  const iconixGames = ["crashgame"];

  const targetProviders = ["rocketman", "spribe", "aviatrix", "spaceman", "jetx"];
  const _games = games;

  const valuesToRemove = [10106,10132,10135];


  return (
    <Translation>
      {(t) => (
        <>
          <Helmet>
            <title>{t("TITLE_VIRTUAL")}</title>
          </Helmet>
          <div>
            <ScrollableListView
              pb={pb}
              title={t("TITLE_GAMES")}
              provider={currentProvider}
              setProvider={setCurrentProvider}

              FilterSearchValue={FilterSearchValue}
              setFilterSearchValue={setFilterSearchValue}
              data={[...(_games ? _games.hasOwnProperty("goldenrace") ? _games["goldenrace"] : [] : []), ...allGamesGameTypes].filter(x => {
                return isGameLaunchAllowed(x, x.vendor, x._midleware, props.permissions, loggedIn);
              }).filter(item => !valuesToRemove.includes(item.id))}
            >
            
              {
                /*
                  <>
           {
            _games && _games.hasOwnProperty("rocketman") && _games["rocketman"].filter((x) => x.enabled == 1).map((item, index) => (
              <InnovaBox key={index} isLive={false} index={index} item={item} />
            ))
           }
           
           {
            _games && _games.hasOwnProperty("spribe") && _games["spribe"].map((item, index) => (
              <InnovaBox key={index} isLive={false} index={index} item={item} />
            ))
           }
           
         
           
           </>
                
                */
              }

            </ScrollableListView>

          </div>
        </>
      )}
    </Translation>
  );
};
/*

                            .reverse()
                            .sort((a, b) =>
                              a.gameIdNumeric > b.gameIdNumeric ? -1 : 1
                            )
*/
const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, permissions, permissionsAll } = authentication;
  const { sports, games, allGames } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    allGames,
    allGamesGameTypes: allGames.filter(x => virtualGameTypes.some(y => y == x.type)),
    permissions,
    permissionsAll,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    UpdateGames: (data) => dispatch(gameAction.UpdateGamesData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Casino);
